export default __webpack_public_path__ + "static/media/feather _ bag.839cdda1.svg";